<template>
     <div>
        <div class="container-fluid featured-image-services">
            <div class="feature-header-page">
                    <h1>Testimonials</h1>
                </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 testimonials-page">
                    <h2>Testimonials</h2>
                    <hr>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row testimonials-boxes">
                <div class="col-lg-4 testimonials-box">
                    <open-quote></open-quote>
                    <p>I always use Harling Taxis. Good rates and friendly drivers, would definitely recommend.</p>
                    <br>
                    <p><b>Aaron Grime</b></p>
                    <close-quote></close-quote>
                </div>
                <div class="col-lg-4 testimonials-box">
                    <open-quote></open-quote>
                    <p>Excellent company. Always friendly and reliable!</p>
                    <br>
                    <p><b>Adam Greenwood</b></p>
                    <close-quote></close-quote>
                </div>
                <div class="col-lg-4 testimonials-box">
                    <open-quote></open-quote>
                    <p>Thank you for your efficient and professional service when an elderly client found herself unexpectedly without transport. We will always recommend you’.</p>
                    <br>
                    <p><b>Karen Lawrence</b></p>
                    <close-quote></close-quote>
                </div>
                <div class="col-lg-6 testimonials-box">
                    <open-quote></open-quote>
                    <p>Thank you!!! Very friendly driver and the person I spoke to on the phone was very helpful. Will definitely be using you again!</p>
                    <br>
                    <p><b>Jess Issit</b></p>
                    <close-quote></close-quote>
                </div>
                <div class="col-lg-6 testimonials-box">
                    <open-quote></open-quote>
                    <p>Reliable, always on time and very polite.</p>
                    <br>
                    <p><b>Mandy Pinnock</b></p>
                    <close-quote></close-quote>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import OpenQuote from '@/components/partials/OpenQuote'
import CloseQuote from '@/components/partials/CloseQuote'

export default {
  name: 'testimonials',
  components: {
    CloseQuote,
    OpenQuote
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Testimonials.vue